module.exports = __webpack_public_path__ + "static/media/StarHalf.3fd153bc.svg";